import { api } from "./client";

export interface LeaderboardBestLapFlight {
  id: number;
  title: string | null;
  session_name: string | null;
  start_time: string | null;
}

export interface LeaderboardEntry {
  rank: number;
  user_id: number;
  username: string;
  flight_count: number;
  best_lap_seconds: number | null;
  best_lap_flight: LeaderboardBestLapFlight | null;
  can_open_flight: boolean;
}

export interface LeaderboardSummary {
  row_count: number;
  scope_label: string;
}

export interface LeaderboardOut {
  missions: string[];
  selected_mission: string | null;
  rows: LeaderboardEntry[];
  summary: LeaderboardSummary;
}

export function getLeaderboards(mission?: string) {
  const qs = mission ? `?mission=${encodeURIComponent(mission)}` : "";
  return api.get<LeaderboardOut>(`/api/leaderboards${qs}`);
}
